import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=978e62e0&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"
import style0 from "./index-old.vue?vue&type=style&index=0&id=978e62e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978e62e0",
  null
  
)

export default component.exports